realDisplayType